import i18n from "i18n/config";
import { CurrencyType, DEFAULT_PRICE_CURRENCY } from "typings/CurrencyType";

export const getFormatCurrencyOptions = (
  currency?: CurrencyType,
  compact = false,
  showCurrencySymbol = true,
): Intl.NumberFormatOptions => ({
  currency: currency ?? DEFAULT_PRICE_CURRENCY,
  currencyDisplay: "narrowSymbol",
  notation: compact ? "compact" : "standard",
  style: showCurrencySymbol || !compact ? "currency" : "decimal",
});

export const formatCurrency = (
  value?: null | number,
  currency?: CurrencyType,
  compact = false,
  showCurrencySymbol = true,
  locales: Intl.LocalesArgument = i18n.language,
) => {
  const options = getFormatCurrencyOptions(
    currency,
    compact,
    showCurrencySymbol,
  );

  const currencyFormat = new Intl.NumberFormat(locales, options);

  const parts = currencyFormat.formatToParts(value ?? 0);

  return parts
    .reduce((acc, part) => {
      if (part.type === "currency" && !showCurrencySymbol) {
        return acc;
      }

      return acc + part.value;
    }, "")
    .trim();
};
